import Vue from "vue";
import Vuex from "vuex";
import offices from "./modules/offices";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    offices
  },
  state: {
    openedLayer: false,
    currentStepSlug: "",
    currentStepIndex: 0,
    steps: [
      {
        type: "number",
        title: "Beköltözés",
        data: {
          name: "timing",
          slug: "bekoltozes",
          label: "Mikor szeretnél beköltözni?",
          description:
            "Hány hónapon belül szeretnél beköltözni az új irodádba?",
          unit: "hó",
          longunit: "hónap",
          min: 1,
          max: 12,
          step: 1
        }
      },
      {
        type: "numselect",
        title: "Futamidő",
        data: {
          name: "length",
          slug: "futamido",
          label: "Futamidő?",
          description:
            "Hány évre tervezel irodát bérelni? Gondolj arra, hogy milyen távlati jövő vár a cégedre!",
          unit: "év",
          longunit: "év",
          items: [
            { key: "1-3", label: "1-3" },
            { key: "3-5", label: "3-5" },
            { key: "5+", label: "5+" }
          ]
        }
      },
      {
        type: "checkbox",
        title: "Lokáció",
        data: {
          name: "location",
          slug: "lokacio",
          label: "Hol szeretnél irodát bérelni?",
          description:
            "Egy iroda meghatározó karaktere a helyszín, kérlek válaszd ki azokat a területeket, amelyek érdekelnek.",
          unit: "",
          longunit: "",
          items: [
            { key: "buda-north", label: "Észak-Buda" },
            { key: "buda-central", label: "Buda Központ" },
            { key: "buda-south", label: "Dél-Buda" },
            { key: "pest-central", label: "Belváros" },
            { key: "vaci-corridor", label: "Váci Corridor" },
            { key: "pest-central-north", label: "Észak-Pest" },
            { key: "pest-central-south", label: "Dél-Pest" },
            { key: "pest-non-central", label: "Pest Külváros" },
            { key: "periphery", label: "Budapest környezete" },
            { key: "other", label: "Egyéb" }
          ]
        }
      },
      {
        type: "radio",
        title: "Kialakítás",
        data: {
          name: "layout",
          slug: "kialakítas",
          label: "Milyen irodai elrendezésben éreznéd jól magad?",
          description: "",
          unit: "",
          longunit: "",
          items: [
            { key: "open-space", label: "Nyitott" },
            { key: "mixed", label: "Vegyes" },
            { key: "cellular", label: "Cellás" }
          ]
        }
      },
      {
        type: "range",
        title: "Méret",
        data: {
          name: "size",
          slug: "meret",
          label: "Hány négyzetméterre van szükséged?",
          description:
            "Személyenként átlagosan 12 m2-re van szükség! Gondolj a céged növekedésére is!",
          unit: "m2",
          longunit: "Négyzetméter",
          min: 10,
          max: 1000,
          step: 1
        }
      },
      {
        type: "multirange",
        title: "Büdzsé",
        data: {
          name: "budget",
          slug: "budzse",
          label: "Milyen büdzsével rendelkezel?",
          description: "",
          items: {
            monthly: {
              label: "Havonta",
              unit: "€/hó",
              longunit: "Euro/Hónap",
              min: 100,
              max: 100000,
              step: 10
            },
            sqm: {
              label: "Négyzetméterenként",
              unit: "€/m2",
              longunit: "/Négyzetméter",
              min: 1,
              max: 500,
              step: 1
            }
          }
        }
      }
    ],
    answers: JSON.parse(localStorage.getItem("answers")) || [],
    personal: JSON.parse(localStorage.getItem("personal")) || {
      name: "",
      email: "",
      phone: ""
    },
    testimonials: [
      {
        name: "Kristoffer Waardahl",
        pic: null,
        color: "white",
        text:
          "Régóta dolgozunk együtt irodabérléssel és bérbeadással kapcsolatban is az Offie csapatával. Az elmúlt évek szoros együttműködése mellett egy bizalmi viszony alakult ki, amely végig töretlen maradt. Csak pozitívan tudok nyilatkozni az Offie tapasztalatait és ügyfélkezelését illetően.",
        sign: "Build a Rocket Boy, CEO",
        link: "https://buildarocketboy.com"
      },
      {
        name: "Horváth Tamás",
        pic: null,
        color: "white",
        text:
          "az OFFIE by FWD a partnerei érdekeit szem előtt tartó, a tökéletes megoldásra törekvő, fiatal és agilis vállakozás - bátran ajánlom bárkinek, aki irodabérlés előtt áll...",
        sign: "Bayer Hungária, Project Manager",
        link: "http://www.bayerhungaria.hu"
      },
      {
        name: "Tálos Zoltán",
        pic: null,
        color: "white",
        text:
          "A vállalat speciális igényeinek az OFFIE (by Forward Advisory) tanácsadói csapata magasan az elvárások felett megfelelt. Minden helyzetben megtalálták számunkra a tökéletes megoldást.",
        sign: "LeanPay, CEO",
        link: "https://www.leanpay.si"
      },
      {
        name: "Szűcs Judit",
        pic: null,
        color: "white",
        text:
          "Megtalálni számunkra az új irodát dilemma volt. Az OFFIE csapat annyira gördülékennyé és könnyűvé tette a folyamatot, amire nem is számítottunk! Ajánlom mindazoknak, akik irodabérlés előtt állnak. Ne halogassátok, kérjetek segítséget az OFFIE by Forward Advisory csapattól!",
        sign: "BlueBird, Head of Operations",
        link: "https://bluebird.hu"
      },
      {
        name: "Károly Lovész",
        pic: null,
        color: "white",
        text:
          "Speciális igényekkel és szűk határidőkkel kezdtük az irodakeresést, az Offie csapata azonban magasan felülmúlta az elvárásainkat. A határidők és egyedi elvárások ellenére megtalálták azt az irodát, ami valóban illik a csapat profiljához, és jól kezelték a vállalat Ausztrál székhelyéből adódó kapcsolattartási extremitását is.",
        sign: "Applied EV, Software Engineering Manager",
        link: "https://www.appliedev.com"
      }
    ],
    buildings: [
      {
        name: "Költözz a Szépvölgyi Irodaházba",
        slug: "szepvolgy",
        description:
          "Kiadó irodák hiánypótló, “A” kategóriájú irodaházban, amely csakúgy megad mindent bérlőinek mint a belvárosi irodák, ráadásul gyönyörű, zöldövezeti környezetben helyezkedik el. Mindegyik iroda hatalmas ablakokkal felszerelt, így rengeteg a természetes fény és gyönyörű kilátás nyílik a környező kertre és erdőre.",
        address: "1037 Budapest, Montevideo utca 14.",
        images: [
          {
            src: "/buildings/szepvolgyi/office-building-szepvolgyi.webp",
            width: "1920",
            height: "1044",
            alt: "The office building in Szépvölgy",
            main: true
          },
          {
            src: "/buildings/szepvolgyi/carousel-1.webp",
            width: "1920",
            height: "1081",
            alt: "The office building in Szépvölgy"
          },
          {
            src: "/buildings/szepvolgyi/carousel-2.webp",
            width: "1920",
            height: "960",
            alt: "The office building in Szépvölgy"
          },
          {
            src: "/buildings/szepvolgyi/carousel-3.webp",
            width: "1920",
            height: "1440",
            alt: "The office building in Szépvölgy"
          },
          {
            src: "/buildings/szepvolgyi/carousel-4.webp",
            width: "1920",
            height: "1044",
            alt: "The office building in Szépvölgy"
          }
        ],
        contact: "",
        features: [
          "raised floor",
          "immediately move in",
          "suspended ceiling",
          "convenient parking",
          "electric dimming",
          "good public transport"
        ]
      },
      {
        name: "Költözz a Budapart Citybe",
        slug: "budapart-city",
        description:
          "Egy rendkívül stabil hátterű német multinacionális cég albérletbe adja irodaterületének kihasználatlan területét. Az iroda teljesen újonnan került kialakításra és teljesen függetlenített az albérletbeadótól, azonnal költözhető, akár bútorozottan is. A bérleti díj tartalmazza a parkolóhelyeket és tárolóhely is rendelkezésre áll. A kiváló felszereltségi minőség mellett a környék számtalan magas színvonalú szolgáltatásának és kényelmének köszönhetően inspiráló környezetet biztosítanak a dolgozóknak.",
        address: "1117 Budapest, Dombóvári út 27.",
        images: [
          {
            src: "/buildings/budapart/office-building-budapart.webp",
            width: "1920",
            height: "1044",
            alt: "Move to Budapart City",
            main: true
          },
          {
            src: "/buildings/budapart/budapark1.webp",
            width: "1920",
            height: "2559",
            alt: "Move to Budapart City"
          },
          {
            src: "/buildings/budapart/budapark2.webp",
            width: "1920",
            height: "800",
            alt: "Move to Budapart City"
          },
          {
            src: "/buildings/budapart/budapark3.webp",
            width: "1920",
            height: "1346",
            alt: "Move to Budapart City"
          },
          {
            src: "/buildings/budapart/budapark4.webp",
            width: "1920",
            height: "2880",
            alt: "Move to Budapart City"
          },
          {
            src: "/buildings/budapart/budapark5.webp",
            width: "1920",
            height: "2882",
            alt: "Move to Budapart City"
          },
          {
            src: "/buildings/budapart/budapark6.webp",
            width: "1920",
            height: "1280",
            alt: "Move to Budapart City"
          }
        ],
        contact: "",
        features: [
          "raised floor",
          "immediately move in",
          "suspended ceiling",
          "convenient parking",
          "electric dimming",
          "good public transport"
        ]
      }
    ],
    messages: {
      valueMissing: "Kötelező mező!",
      typeMismatch: "Nem megfelelő típus!",
      badInput: "Hibás érték!",
      patternMismatch: "Nem megfelelő formátum!",
      rangeOverflow: "Tartományon kívül esik!",
      tooLong: "Az érték túl hosszú!",
      tooShort: "Az érték túl rövid"
    }
  },
  mutations: {
    setStepByIndex(state, index) {
      // console.log("SET");
      state.currentStepIndex = index;
      state.currentStepSlug = state.steps[index].data.slug;
    },
    setStepBySlug(state, slug) {
      state.currentStepSlug = slug;
      state.currentStepIndex = this.getters.getStepIndexBySlug(slug);
    },
    setAnswer(state, answer) {
      state.answers[answer.index] = answer.value;
      localStorage.setItem("answers", JSON.stringify(state.answers));
    },
    setAnswers(state, answers) {
      state.answers = answers;
      localStorage.setItem("answers", JSON.stringify(state.answers));
    },
    setAnswerBySlug(state, data) {
      const index = this.getters.getStepIndexBySlug(data.slug);
      // console.log(data.key, state.answers[index][data.key])
      state.answers[index][data.key] = data.value;
      localStorage.setItem("answers", JSON.stringify(state.answers));
    },
    setPersonal(state, personal) {
      state.personal = personal;
      localStorage.setItem("personal", JSON.stringify(state.personal));
    },
    setOpenedLayer(state, opened) {
      state.openedLayer = opened;
    }
  },
  actions: {},
  getters: {
    getOpenedLayer: state => state.openedLayer,
    getStep: state => state.steps[state.currentStepIndex],
    getStepIndex: state => state.currentStepIndex,
    getStepSlug: state => state.currentStepSlug,
    getSteps: state => state.steps,
    getStepBySlug: state => slug =>
      state.steps.find(object => object.data.slug === slug),
    getStepIndexBySlug: state => slug =>
      state.steps.map(object => object.data.slug).indexOf(slug),
    getAnswers: state => state.answers,
    getAnswerBySlug: state => slug =>
      state.answers[
        state.steps.map(object => object.data.slug).indexOf(slug)
      ] || 0,
    getPersonal: state => state.personal,
    getMessages: state => state.messages,
    getMessage: state => key => state.messages[key] || null,
    getTestimonials: state => state.testimonials,
    getBuildings: state => state.buildings,
    getBuildingBySlug: state => slug =>
      state.buildings.find(object => object.slug === slug)
  }
});
